import PropTypes from 'prop-types';
import styles from './ClipAnimation.module.css';

function ClipAnimation({ children = null, fullWidth = false, startAnimation = false, longDuration, reversed }) {
  return (
    <div
      className={`aaco-clip-animation ${fullWidth ? 'w-full' : 'w-fit'} ${
        styles.clip
      } ${startAnimation ? styles.reveal : ''} ${longDuration ? styles.long : ''} ${reversed ? styles.reverse : ''}`}
    >
      {children}
    </div>
  );
}

ClipAnimation.propTypes = {
  children: PropTypes.node,
  fullWidth: PropTypes.bool,
  startAnimation:  PropTypes.bool,
};



export default ClipAnimation;
